import { render } from "./NumberType.vue?vue&type=template&id=493d6c62"
import script from "./NumberType.vue?vue&type=script&lang=js"
export * from "./NumberType.vue?vue&type=script&lang=js"

import exportComponent from "/home/jeim2750/fuelguide.be/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__